import './src/styles/fonts.css'
import './src/styles/global.css'

import {windowScrollToPolyfill, elementScrollIntoViewPolyfill} from 'seamless-scroll-polyfill'

windowScrollToPolyfill()
elementScrollIntoViewPolyfill()
